export * from "@workspace/gamja-platform/components/RedAlert";
export { default } from "@workspace/gamja-platform/components/RedAlert";
